import { instance } from '@/app/libs/I';
import { Request } from '@/app/modules/request/Request';
import { requestService } from '@/app/modules/request/RequestService';
import { stringService } from '@/app/modules/string/StringService';

/**
 * @deprecated legacy
 */
export namespace svcService {
  /**
   * @deprecated legacy
   */
  export function emailByBitrixId(id: string) {
    return requestService.apply<{
      'errorCode': 0,
      'response': {
        'msg': string,
        'email': string
      }
    }>(instance(
      Request,
      stringService.replaceHolder('id', id, '/api/emailByBitrixId/{id}'),
      Request.GET,
      Request.targets.SVC,
    ));
  }
}
